import React, { useEffect, useState } from 'react';
import styles from './index.scss'
import { SettingOutlined } from '@ant-design/icons'
import { Popover, Checkbox } from 'antd';
import { ze } from 'utils/zhEn';
import { useLocalStorageStateOfFieldTopStats } from 'utils/react-hooks/cs-local-storage-hooks';

export function FieldTopStatus({ onChange, t }) {
  const [checkboxSelectOptions, setCheckboxSelectOptions] = useState([
    { label: t('RANKINGLIST.应用版本'), value: 'app', disabled: false },
    { label: t('RANKINGLIST.系统版本'), value: 'system', disabled: false },
    { label: t('REPORTDETAIL.gpu'), value: 'gpu', disabled: false },
    { label: t('issueCrashFilterKey.cpu'), value: 'cpu', disabled: false },
    { label: t('issueCrashFilterKey.gpuDriverVersion'), value: 'gpuDriverVersion', disabled: false }
  ]);
  // 将状态存储到localStorage
  const [csTopStatus, setCsTopStatus] = useLocalStorageStateOfFieldTopStats();
  const [selectValue, setselectValue] = useState([])


  useEffect(() => {
    // 设置选中状态，没有本地存储则设置默认值
    const defaultSelected = csTopStatus.pcSelectedFields?.length ? csTopStatus.pcSelectedFields : ['app', 'system', 'gpu', 'cpu']
    setselectValue(defaultSelected)
    // 设置禁用状态
    setCheckboxSelectOptions(checkboxSelectOptions.map(item => ({
      ...item,
      disabled: defaultSelected.length > 3 && !defaultSelected.includes(item.value)
    })))
    onChange(defaultSelected)
  }, []);

  return (
    <Popover
      title={<div className={styles.title}>{ze('仅支持最多选择4项维度','Only a maximum of 4 dimensions can be selected.')}</div>}
      overlayClassName={styles.pop} // 修改Popover默认的样式
      showArrow={false}
      trigger='click'
      placement='bottomLeft'
      content={<div>
        <Checkbox.Group
          className={styles.checkboxGroup}
          options={checkboxSelectOptions}
          value={selectValue}
          style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          onChange={(value) => {
            // 判断选择的选项是否少于1个，如果少于1个则不允许取消选择
            if (value.length < 1) return
            setCsTopStatus({ pcSelectedFields: value })
            setselectValue(value)
            onChange(value)
            // 判断选择的选项是否多于3个，如果多于将剩下的选项禁用
            if (value.length > 3) {
              setCheckboxSelectOptions(checkboxSelectOptions.map(item => ({
                ...item,
                disabled: !value.includes(item.value)
              })))
            } else {
              setCheckboxSelectOptions(checkboxSelectOptions.map(item => ({
                ...item,
                disabled: false
              })))
            }
          }} />
      </div>}
    >
      <div className={styles.settingOutlined}><SettingOutlined /></div>
    </Popover>
  )
}
